import { FC } from 'react';

import { ApiDocumentResponseV2, ApiTaskDocumentResponseV2 } from '@/shared/api';
import { FileTypeIcon } from '@/shared/components/FileTypeIcon';
import { Icon, IconProps } from '@/shared/uikit/Icon';

import { getExternalIconByDtoId } from '../helpers';

type FileIconProps = {
  file: ApiDocumentResponseV2 | ApiTaskDocumentResponseV2;
} & Omit<IconProps, 'name'>;

export const VfoFileIcon: FC<FileIconProps> = ({ file, ...props }) => {
  const isExternal = file.source === 'EXTERNAL';
  const extIcon = file.dtoId && isExternal ? getExternalIconByDtoId(file.dtoId) : null;

  return extIcon ? (
    <Icon name={extIcon} {...props} />
  ) : (
    <FileTypeIcon type={file.fileType} {...props} />
  );
};
